<div class="decoration-container">
  <span class="glow glow-pink"></span>
  <span class="glow glow-yellow"></span>
  <span class="glow glow-green"></span>

  <img src="assets/images/ellipse-pink.svg" alt="" class="icon ellipse-pink" />

  <img src="assets/icons/static-loading.svg" alt="" class="icon static-loading" />

  <img src="assets/images/ellipse-blue.svg" alt="" class="icon ellipse-blue" />

  <img src="assets/images/ellipse-yellow.svg" alt="" class="icon ellipse-yellow" />

  <img src="assets/images/square-yellow.svg" alt="" class="icon square-yellow" />
  
  <img src="assets/icons/like.svg" alt="" class="icon like" />

  <img src="assets/images/square-green.svg" alt="" class="icon square-green" />
  
  <img src="assets/images/login-arrow.svg" alt="" class="icon login-arrow" />
</div>
